import { Download1Stroke, Pencil1Stroke, PlusStroke, Search1Stroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAdd: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onCopy: () => void;
  onSearch: () => void;
  onRefresh: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export default function ActionBar({
  className,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onSearch,
  onRefresh,
  isEditDisabled = true
}: ActionBarProps) {
  return (
    <ActionBarV2 className={className} title='Phiếu nhập hàng bán trả lại'>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xoá' onClick={onDelete} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopy} disabled={isEditDisabled} />
      <ActionButtonV2 icon={Search1Stroke} title='Tìm kiếm' onClick={onSearch} />
      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
}
